import { useEffect, useRef, useState } from "react";

export function useTopLoader(active: boolean, delay = 200) {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const delayRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (active) {
      delayRef.current = setTimeout(() => {
        setVisible(true);
        setProgress(10);

        intervalRef.current = setInterval(() => {
          setProgress((prev) => {
            if (prev >= 90) return prev;
            return prev + Math.random() * 10;
          });
        }, 300);
      }, delay);
    } else {
      if (delayRef.current) clearTimeout(delayRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);

      if (visible) {
        setProgress(100);
        setTimeout(() => {
          setVisible(false);
          setProgress(0);
        }, 300);
      }
    }

    return () => {
      if (delayRef.current) clearTimeout(delayRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [active, delay, visible]);

  return { visible, progress };
}
